module.exports = __webpack_public_path__ + "img/jucai6.31072827.jpg";